import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { useNewPasswordFormViewController } from './NewPasswordViewController';
import { UseNewPasswordView } from './UseNewPasswordView';

export const NewPasswordForm = () => {
  const { uiState, actions } = useNewPasswordFormViewController();

  if (uiState.isPasswordSubmitted) {
    return <UseNewPasswordView />;
  }

  return (
    <Box
      sx={{
        height: '100vh',
        bgcolor: 'grey.100',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        pt: { xs: 4, sm: 8 },
      }}
    >
      <Paper
        sx={{
          p: { xs: 2, sm: 3 },
          borderRadius: 2,
          maxWidth: '430px',
          width: '100%',
          mt: { xs: 5, sm: 10 },
          mx: { xs: 2, sm: 0 },
        }}
      >
        <Typography variant="h4" sx={{ mb: 2 }}>
          Restablece tu contraseña
        </Typography>
        <Box>Contraseña nueva</Box>
        <TextField
          fullWidth
          label="Contraseña nueva"
          type={uiState.showPassword ? 'text' : 'password'}
          variant="outlined"
          margin="normal"
          value={uiState.password}
          onChange={actions.onPasswordChanged}
          error={Boolean(uiState.passwordError)}
          helperText={uiState.passwordError}
          FormHelperTextProps={{
            sx: { minHeight: 'max-content', whiteSpace: 'normal' },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={actions.togglePasswordVisibility}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  {uiState.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Box sx={{ mt: 1 }}>Reintroducir contraseña</Box>
        <TextField
          fullWidth
          label="Confirmar contraseña"
          type={uiState.showConfirmPassword ? 'text' : 'password'}
          variant="outlined"
          margin="normal"
          value={uiState.confirmedPassword}
          onChange={actions.onConfirmedPasswordChanged}
          error={Boolean(uiState.confirmedPasswordError)}
          helperText={uiState.confirmedPasswordError}
          FormHelperTextProps={{
            sx: { minHeight: 'max-content', whiteSpace: 'normal' },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={actions.toggleConfirmPasswordVisibility}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  {uiState.showConfirmPassword ? (
                    <VisibilityOff />
                  ) : (
                    <Visibility />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button
          variant="contained"
          fullWidth
          sx={{ mt: '16px' }}
          onClick={actions.handleSubmit}
          disabled={uiState.isButtonDisabled}
        >
          Cambiar contraseña
        </Button>
      </Paper>
    </Box>
  );
};
